// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchInput_input_12zpu","root":"SearchInput_root_7bn3M","isPrimary":"SearchInput_isPrimary_1LDxL"};